import React from 'react';
import PropTypes from 'prop-types';
import OrderDetails from "./../component/OrderDetails";
import PersonalInfo from "./../component/PersonalInfo";
import AcceptTermsContainer from "./../containers/AcceptTermsContainer";
import ProceedToPaymentContainer from "../containers/ProceedToPaymentContainer";
import $ from "jquery";

class OrderForm extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            step: 1,
        }

        this.handleContinueClick = this.handleContinueClick.bind(this)
        this.handleBackToOrderDetailsClick = this.handleBackToOrderDetailsClick.bind(this)
    }

    handleContinueClick() {
        this.setState({step: 2});
        this.scrollTopOrderForm();
    }

    handleBackToOrderDetailsClick() {
        this.setState({step: 1})
    }

    scrollTopOrderForm() {
        var positionTopOrderForm = $('#order_form').position().top;
        $("html, body").animate({scrollTop: positionTopOrderForm}, 500);
    }

    render() {
        const selectedDoctypeId = this.props.selectedDoctypeId
        const selectedLevelId = this.props.selectedLevelId
        const selectedUrgencyId = this.props.selectedUrgencyId
        const selectedVasIds = this.props.selectedVasIds || []
        const selectedVasItems = this.props.selectedVasItems || {}
        const selectedCoverLettersCount = this.props.selectedCoverLettersCount
        const discountCode = this.props.discountCode
        const step = this.state.step

        if (this.props.countValidations > 0 && this.props.issetValidationErrors) {
            this.scrollTopOrderForm();
        }

        return (
            <div>
                <form action="/order/" method="post" id="order_form" className="main">
                    {step === 1 &&
                        <OrderDetails onContinueClick={this.handleContinueClick} />
                    }
                    {step === 2 &&
                        <div>
                            <PersonalInfo onBackToOrderDetailsClick={this.handleBackToOrderDetailsClick} />
                            <div className="row">
                                <div className="col-lg-8 col-md-12">
                                    <div className="terms-w">

                                        <AcceptTermsContainer />
                                        <ProceedToPaymentContainer />

                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <input type="hidden" name="doctype" value={selectedDoctypeId} />
                    <input type="hidden" name="cover_letters" value={selectedCoverLettersCount} />
                    <input type="hidden" name="wrlevel" value={selectedLevelId} />
                    <input type="hidden" name="urgency" value={selectedUrgencyId} />
                    <input type="hidden" name="promo" value={discountCode} />
                    {selectedVasIds.map(vasId => (
                        <input key={vasId} type="hidden" name={'additional[' + vasId + ']'} value={'additional[' + vasId + ']'} />
                    ))}
                    {Object.keys(selectedVasItems).map(vasId => (
                        <input key={vasId} type="hidden" name={'count_additional[' + vasId + ']'} value={selectedVasItems[vasId]} />
                    ))}
                    <input type="hidden" value="true" name="proceed"/>
                </form>
            </div>
        )
    }
}

OrderForm.propTypes = {
    selectedDoctypeId: PropTypes.number,
    selectedLevelId: PropTypes.number,
    selectedUrgencyId: PropTypes.number,
    selectedVasIds: PropTypes.arrayOf(PropTypes.number),
    selectedVasItems: PropTypes.objectOf(PropTypes.number),
    selectedCoverLettersCount: PropTypes.number,
    discountCode: PropTypes.string,
}

export default OrderForm

